var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mod__no-data"},[_c('div',{staticClass:"no-data-box"},[_c('Icon',{staticClass:"no-data-icon",attrs:{"name":"block"}}),_vm._v(" "),_vm._t("default",function(){return [_c('span',{staticClass:"no-data-text"},[_vm._v(_vm._s(_vm.text || _vm.$t('no-data')))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }